function setMeta(attr: 'name' | 'property', key: string, content: string) {
  const selector = attr === 'name' ? `meta[name="${key}"]` : `meta[property="${key}"]`;
  let el = document.head.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function removeRobotsMeta() {
  document.head.querySelectorAll('meta[name="robots"]').forEach((el) => el.remove());
}

function setNoIndex() {
  setMeta('name', 'robots', 'noindex, nofollow');
}

export interface HeadData {
  title: string;
  description: string;
  keywords: string;
  canonical: string;
  ogType: string;
  ogImage: string;
  ogImageAlt: string;
  locale: string;
}

export function applyHead(data: HeadData) {
  document.title = data.title;
  setMeta('name', 'description', data.description);
  setMeta('name', 'keywords', data.keywords);
  setCanonical(data.canonical);

  setMeta('property', 'og:title', data.title);
  setMeta('property', 'og:description', data.description);
  setMeta('property', 'og:url', data.canonical);
  setMeta('property', 'og:type', data.ogType);
  setMeta('property', 'og:image', data.ogImage);
  setMeta('property', 'og:image:alt', data.ogImageAlt);
  setMeta('property', 'og:locale', data.locale);

  setMeta('name', 'twitter:card', 'summary_large_image');
  setMeta('name', 'twitter:title', data.title);
  setMeta('name', 'twitter:description', data.description);
  setMeta('name', 'twitter:image', data.ogImage);
}

export function applyNotFound() {
  document.title = 'Page Not Found';
  setNoIndex();
}

export function clearJsonLd() {
  document.querySelectorAll('script[data-seo-jsonld]').forEach((el) => el.remove());
}

export function injectJsonLd(id: string, data: Record<string, unknown>) {
  const existing = document.getElementById(id);
  if (existing) existing.remove();

  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.id = id;
  script.setAttribute('data-seo-jsonld', 'true');
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
}